import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  CircularProgress,
  Tabs,
  Tab,
  Box,
  Card,
  Fade,
} from "@mui/material";
import ListAltIcon from "@mui/icons-material/ListAlt";
import ScienceIcon from "@mui/icons-material/Science";
import { getVersions } from "../../../Services/VersionsApi";
import DemoVersionTap from "./DemoTap/DemoVersionTap"; // Import DemoVersionTap
import AllVersionTap from "./AllVersionTap/AllVersionTap"; // Import AllVersionTap

const VersionsPage = () => {
  const [versions, setVersions] = useState([]);
  const [demoVersions, setDemoVersions] = useState([]); // State for demo versions
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(0); // State for active tab

  useEffect(() => {
    getVersions()
      .then((res) => {
        const allVersions = res.data.data || [];
        setVersions(allVersions);
        setDemoVersions(allVersions.filter((v) => v.is_demo)); // Filter demo versions
      })
      .catch(() => {
        setVersions([]);
        setDemoVersions([]);
      })
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    const savedTab = localStorage.getItem("activeTab");
    if (savedTab !== null) {
      setActiveTab(Number(savedTab)); // Retrieve active tab from localStorage
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    localStorage.setItem("activeTab", newValue); // Save active tab to localStorage
  };

  return (
    <Box sx={{ p: 3, backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="h4" 
          sx={{ 
            fontWeight: 700, 
            color: '#1976d2',
            mb: 1,
          }}
        >
          إدارة النسخ
        </Typography>
        <Typography variant="body2" color="text.secondary">
          إدارة جميع النسخ والنسخ التجريبية للنظام
        </Typography>
      </Box>

      {/* Tabs Card */}
      <Card 
        sx={{ 
          boxShadow: 3,
          borderRadius: 2,
          overflow: 'hidden',
          mb: 3,
        }}
      >
        <Tabs 
          value={activeTab} 
          onChange={handleTabChange}
          sx={{
            backgroundColor: 'white',
            '& .MuiTabs-indicator': {
              height: 3,
              backgroundColor: '#1976d2',
            },
          }}
        >
          <Tab 
            icon={<ListAltIcon />}
            iconPosition="start"
            label="جميع النسخ" 
            sx={{
              flex: 1,
              fontSize: '1rem',
              fontWeight: 600,
              py: 2.5,
              textTransform: 'none',
              color: activeTab === 0 ? '#1976d2' : '#666',
              '&:hover': {
                backgroundColor: '#f0f7ff',
              },
              '&.Mui-selected': {
                color: '#1976d2',
              },
            }}
          />
          <Tab 
            icon={<ScienceIcon />}
            iconPosition="start"
            label="النسخ التجريبية" 
            sx={{
              flex: 1,
              fontSize: '1rem',
              fontWeight: 600,
              py: 2.5,
              textTransform: 'none',
              color: activeTab === 1 ? '#1976d2' : '#666',
              '&:hover': {
                backgroundColor: '#f0f7ff',
              },
              '&.Mui-selected': {
                color: '#1976d2',
              },
            }}
          />
        </Tabs>
      </Card>

      {/* Content */}
      {loading ? (
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            minHeight: 400,
            backgroundColor: 'white',
            borderRadius: 2,
            boxShadow: 2,
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress size={60} thickness={4} />
            <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
              جاري تحميل البيانات...
            </Typography>
          </Box>
        </Box>
      ) : (
        <Fade in={!loading} timeout={500}>
          <Box>
            {activeTab === 0 ? (
              <AllVersionTap />
            ) : (
              <DemoVersionTap />
            )}
          </Box>
        </Fade>
      )}
    </Box>
  );
};

export default VersionsPage;
